import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-activity-card',
  templateUrl: './account-activity-card.component.html',
  styleUrls: ['./account-activity-card.component.scss']
})
export class AccountActivityCardComponent implements OnInit {

  showCounter: boolean;

  constructor() {
    this.showCounter = true;
  }

  ngOnInit() {
  }

}
